import { render, staticRenderFns } from "./partners-item.vue?vue&type=template&id=b3324378"
import script from "./partners-item.vue?vue&type=script&lang=js"
export * from "./partners-item.vue?vue&type=script&lang=js"
import style0 from "./partners-item.vue?vue&type=style&index=0&id=b3324378&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports